module.exports = __webpack_public_path__ + "assets/img/chengdu.b7532e4f.png";